"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Picture = /** @class */ (function () {
    function Picture(video, canvasFrame, videoWidth, videoHeight) {
        this.video = video;
        this.canvasFrame = canvasFrame;
        this.videoWidth = videoWidth;
        this.videoHeight = videoHeight;
    }
    Picture.prototype.offpageCopy = function (canvas) {
        canvas.width = this.videoWidth;
        canvas.height = this.videoHeight;
        var canvasContext = canvas.getContext('2d');
        canvasContext.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
    };
    return Picture;
}());
exports.default = Picture;
